import { useCallback, useEffect, useState } from '@redneckz/uni-jsx/lib/hooks';
import { identity } from '../utils/fp/identity.js';
// eslint-disable-next-line max-lines-per-function
export const useForm = (initialState, { resetOnSubmit, onSubmit, normalize, } = {}) => {
    const [formState, setFormStateUnsafe] = useState(initialState);
    const setFormState = useCallback(normalize
        ? (_) => setFormStateUnsafe(_ instanceof Function
            ? (prev) => {
                const _normalize = normalize(_(prev));
                return shellowCompare(prev, _normalize) ? prev : _normalize;
            }
            : normalize(_))
        : setFormStateUnsafe, [normalize]);
    useEffect(() => {
        if (normalize) {
            setFormStateUnsafe(normalize);
        }
    }, [normalize]);
    const [isDirtyForm, setDirtyForm] = useState(false);
    const [dirtyFieldsMap, setDirtyFieldsMap] = useState({});
    const field = useCallback((fieldName, options) => {
        const { parse = identity, format = identity } = options || {};
        return {
            value: format(formState[fieldName]),
            isDirty: isDirtyForm || dirtyFieldsMap[fieldName],
            onChange: (value) => {
                setFormState((prev) => ({ ...prev, [fieldName]: parse(value) }));
                setDirtyFieldsMap((prev) => ({ ...prev, [fieldName]: true }));
            },
        };
    }, [setFormState, isDirtyForm, dirtyFieldsMap]);
    const update = useCallback((_) => {
        setFormState(_);
        setDirtyFieldsMap(_);
    }, []);
    const reset = useCallback(() => {
        setFormState(initialState);
        setDirtyForm(false);
        setDirtyFieldsMap({});
    }, [initialState]);
    const handleSubmit = useCallback((ev) => {
        ev.preventDefault();
        resetOnSubmit ? reset() : setDirtyForm(true);
        onSubmit && onSubmit(formState, ev);
    }, [onSubmit, formState]);
    return [
        formState,
        {
            isDirty: isDirtyForm || Object.values(dirtyFieldsMap).some(Boolean),
            field,
            update,
            reset,
            onSubmit: handleSubmit,
        },
    ];
};
const shellowCompare = (a, b) => Object.keys({ ...a, ...b }).every((key) => a[key] === b[key]);
//# sourceMappingURL=useForm.js.map